const sportResources = {
  en: {
    sport: {
      title: 'Athletes insurance',
      calculator: 'Insurance Calculator',
      'description.title': 'Description',
      'description.text1':
        'Sports are becoming increasingly popular among both young and middle-aged people.\n\nEven the most talented and successful athletes get injured, so sports insurance is an important part of their life and career. To restore health and the opportunity to participate in competitions, you need high-quality and sometimes expensive treatment. The more effective it is, the sooner a person will return to the sport. Regular rest does not help here, and standard methods of CHI therapy, effective for domestic injuries, are insufficient.\n\nThe sportsmen\'s insurance program from "Alatau City Garant" will become a reliable protection for you and will help you to rise to the podium.',
      'description.text1.small':
        'Even the most talented and successful athletes get injured, so sports insurance is an important part of their life and career. The sportsmen\'s insurance program from "Alatau City Garant" will become a reliable protection for you and will help you to rise to the podium.',
      'description.text2': 'Description of the insurance program',
      'description.text3': 'Coverage ',
      'description.text4': '24 hours ',
      'description.text5': 'a day',
      'description.text6':
        'Territory of insurance - Republic of Kazakhstan, when insuring on the territory of the ',
      'description.text7': 'Whole world, ',
      'description.text8': 'an increasing coefficient is applied',
      'description.text9': 'Persons ',
      'description.text99': 'aged 1 to 65 ',
      'description.text10': 'are eligible for insurance',
      'description.text11': 'An insured event is ',
      'description.text12': 'an accident ',
      'description.text13':
        'that resulted in the death of the Insured, the establishment of disability, temporary disability / temporary disorder of body functions..',
      'description.text14': 'The payment is set at the rate of:',
      'description.text15': 'Upon death, 100% of the insured amount;',
      'description.text16':
        'When determining the disability of group I - 75% of the insured amount;',
      'description.text17':
        'When establishing disability of group II - 50% of the insured amount;',
      'description.text18':
        'When establishing disability of group III - 30% of the insured amount;',
      'description.text19':
        'Category "disabled child" - 60% of the insured amount;',
      'description.text20':
        'In case of injury, injury without disability - 0.2% of the insured amount, for each day of treatment, starting from the eighth day, but not more than 30 (thirty) days for one insured event.',
    },
  },
  kz: {
    sport: {
      title: 'Спортшыларды сақтандыру',
      calculator: 'Сақтандыру калькуляторы',
      'description.title': 'Сипаттамасы',
      'description.text1':
        'Спорт жастар мен орта жастағы адамдар арасында өте танымал.\n\nТіпті ең талантты және жолы болатын спортшылар да жарақат алады, сондықтан спорттық сақтандыру олардың өмірі мен мансабының маңызды бөлігі болып табылады. Денсаулықты қалпына келтіру және жарыстарға қатысу мүмкіндігі үшін сізге сапалы және кейде қымбат емдеу қажет. Ол неғұрлым тиімді болса, адам спортқа тезірек оралады. Мұнда әдеттегі демалыс көмектеспейді, ал тұрмыстық жарақаттарға әсер ететін ММС терапиясының стандартты әдістері жеткіліксіз.\n\n"Alatau City Garant" спортшыларды сақтандыру бағдарламасы сіз үшін сенімді қорғаныс болады және тұғырға көтерілуге көмектеседі.',
      'description.text1.small':
        'Тіпті ең талантты және жолы болатын спортшылар да жарақат алады, сондықтан спорттық сақтандыру олардың өмірі мен мансабының маңызды бөлігі болып табылады. "Alatau City Garant" спортшыларды сақтандыру бағдарламасы сіз үшін сенімді қорғаныс болады және тұғырға көтерілуге көмектеседі.',
      'description.text2': 'Сақтандыру бағдарламасының сипаттамасы',
      'description.text3': 'Қамту ',
      'description.text4': 'тәулігіне',
      'description.text5': '24 сағат ',
      'description.text6': 'Сақтандыру аумағы - Қазақстан Республикасы, ',
      'description.text7': 'Бүкіл әлем',
      'description.text8':
        ' аумағы бойынша сақтандыру кезінде, арттыру коэффициенті қолданылады',
      'description.text9': 'Сақтандыруға ',
      'description.text99': '1 жастан 65 жасқа ',
      'description.text10': 'дейінгі адамдар қабылданады',
      'description.text11':
        'Сақтандырылған тұлғаның қайтыс болуына мүгедектіктің белгіленуіне еңбекке қабілеттілігінің уақытша жоғалуына / дене функцияларының уақытша бұзылуына әкеп соққан ',
      'description.text12': 'жазатайым оқиға',
      'description.text13': ' сақтандыру жағдайы болып табылады.',
      'description.text14': 'Төлем мөлшерінде белгіленеді:',
      'description.text15':
        'Қайтыс болған жағдайда, сақтандыру сомасының 100%;',
      'description.text16':
        'I топтағы мүгедектік белгіленген кезде-сақтандыру сомасының 75%;',
      'description.text17':
        'II топтағы мүгедектік белгіленген кезде-сақтандыру сомасының 50%;',
      'description.text18':
        'III топтағы мүгедектік белгіленген кезде - сақтандыру сомасының 30%;',
      'description.text19':
        '"Мүгедек бала" санаты кезінде-сақтандыру сомасының 60%;',
      'description.text20':
        'Мүгедектік белгіленбей жарақат алған кезде-сақтандыру сомасының 0,2%, әрбір емделген күн үшін, сегізінші күннен бастап, бірақ бір сақтандыру жағдайы бойынша 30 (отыз) күннен аспайды.',
    },
  },
  ru: {
    sport: {
      title: 'Страхование спортсменов',
      calculator: 'Калькулятор страхования',
      'description.title': 'Описание',
      'description.text1':
        'Спорт очень популярен как среди молодежи, так и людей среднего возраста.\n\nДаже самые талантливые и удачливые атлеты травмируются, поэтому спортивная страховка — важная часть их жизни и карьеры. Для восстановления здоровья и возможности участвовать в соревнованиях нужно качественное и порой дорогостоящее лечение. Чем оно эффективнее, тем скорее человек вернется в спорт. Обычный отдых здесь не помогает, а стандартные методы терапии по ОМС, действенные при бытовых травмах, оказываются недостаточными.\n\nПрограмма страхования спортсменов от «Alatau City Garant» станет для Вас надежной защитой и поможет подняться на пьедестал.',
      'description.text1.small':
        'Даже самые талантливые и удачливые атлеты травмируются, поэтому спортивная страховка — важная часть их жизни и карьеры. Программа страхования спортсменов от «Alatau City Garant» станет для Вас надежной защитой и поможет подняться на пьедестал.',
      'description.text2': 'Описание программы страхования',
      'description.text3': 'Покрытие ',
      'description.text4': '24 часа ',
      'description.text5': 'в сутки',
      'description.text6':
        'Территория страхования - Республика Казахстан, при страховании по территории ',
      'description.text7': 'Весь мир, ',
      'description.text8': 'применяется повышающий коэффициент',
      'description.text9': 'На страхование принимаются лица в возрасте ',
      'description.text10': 'от 1 до 65 лет',
      'description.text11': 'Страховым случаем является ',
      'description.text12': 'несчастный случай ',
      'description.text13':
        'приведший к смерти Застрахованного, установлению инвалидности, временной утрате трудоспособности / временному растройству функций организма..',
      'description.text14': 'Выплата устанавливается в размере:',
      'description.text15': 'При смерти 100% от страховой суммы;',
      'description.text16':
        'При установлении инвалидности I группы - 75% от страховой суммы;',
      'description.text17':
        'При установлении инвалидности II группы - 50% от страховой суммы;',
      'description.text18':
        'При установлении инвалидности III группы - 30% от страховой суммы;',
      'description.text19':
        'При категорий «ребенок- инвалид» - 60% от страховой суммы;',
      'description.text20':
        'При получении увечья, травмы без установления инвалидности - 0,2% от страховой суммы, за каждый день лечения, начиная с восьмого дня, но не более 30 (тридцати) дней по одному страховому случаю.',
    },
  },
};

export default sportResources;
